import React from "react";
import UnattendedAccessTermsAcceptanceList from "../../components/event/UnattendedAccessTermsAcceptanceList";

const UnattendedAccessTermsAcceptancesPage = () => {
    return <UnattendedAccessTermsAcceptanceList/>
}

export default UnattendedAccessTermsAcceptancesPage;
